import React, { useRef, useState,useEffect } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import logo1 from '../Assets/Images/akanksha1.png';
import './style.css';

export const TicketGenerate = () => {
  const [numItems, setNumItems] = useState();
  const [items, setItems] = useState([]);
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('');
  const [Seatno, setSeatno] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [venue, setVenue] = useState('');
  const [showName, setShowName] = useState('');
  const [showNames, setShowNames] = useState(null);
  const [preview, setPreview] = useState(null);

  const pdfContainerRef = useRef(null);
  useEffect(() => {
  return () => {
    if (preview) URL.revokeObjectURL(preview);
  };
}, [preview]);

  const generatePDFs = async () => {
    const container = pdfContainerRef.current;
    const pdfs = [];

    for (let i = 0; i < numItems; i++) {
      const element = container.querySelector(`#pdf-component-${i + 1}`);
      const canvas = await html2canvas(element, { scale: 2 });
      const imageData = canvas.toDataURL('image/jpeg');
      pdfs.push(imageData);
    }

    const mergedPDF = new jsPDF('landscape', 'mm', 'a4');
    pdfs.forEach((imageData, index) => {
      if (index > 0) {
        mergedPDF.addPage();
      }
      mergedPDF.addImage(imageData, 'JPEG', 0, 0, 297, 210);
    });

    mergedPDF.save(`${category}-${Seatno}-${numItems}`);
  };


  const handleInputChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setNumItems(value);
  };

  const handleGeneratePDFs = () => {
    const newItems = [];
    for (let i = 1; i <= numItems; i++) {
      newItems.push({
        id: i,
        title: `Item ${i}`,
        price: `${price}`,
        category: category,
        Seatno: `${Seatno}-${i}`,
        date: date,
        time: time,
        venue: venue,
        showName: showName,
      });
    }
    setItems(newItems);
  };

  return (
    <div>
      <div>
        <input
          type="text"
          value={showName}
          onChange={(e) => setShowName(e.target.value)}
          placeholder='Show Name'
        />
        <input
          type="number"
          value={numItems}
          onChange={handleInputChange}
          placeholder='Numbers of ticket'
        // min={1}
        // max={100}
        />
        <input
          type="text"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          placeholder="price"
        />
        <input
          type="text"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          placeholder="category"
        />
        <input
          type="text"
          value={Seatno}
          onChange={(e) => setSeatno(e.target.value)}
          placeholder="Seatno"
        />
        <input
          type="text"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          placeholder="date"
        />
        <input
          type="text"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          placeholder="time"
        />
        <input
          type="text"
          value={venue}
          onChange={(e) => setVenue(e.target.value)}
          placeholder="Venue"
        />
       <input
  type="file"
  accept="image/*"
  onChange={(e) => {
    const file = e.target.files[0];
    setShowNames(file);
    setPreview(URL.createObjectURL(file)); // 🔥 important
  }}
/>
        <button onClick={handleGeneratePDFs}>Generate Items</button>
      </div>
      <div
        ref={pdfContainerRef}
        className="pdf-container">
        {items.map((item) => (
          <div
            key={item.id}
            className="pdf-component"
            id={`pdf-component-${item.id}`}
          >
            <div className="pdf-header">
              <img className="logo" src={logo1} alt="Logo 1" />
              
            </div>
            <div className="pdf-content">
              <p className="show-name" style={{ display: "flex", alignItems: "center" }}>
                <span>
                  <img className="show-name-img" src={preview} alt="Show" />
                </span>
                {/* <span>{item.showName}</span> */}
              </p>
              <p className="item-details">
                <span className="item-price">Price: {item.price}</span>
                <span className="item-category">{item.category}</span>
                <span className="item-seatno">Seat No.: {item.Seatno}</span>
              </p>
            </div>
            <div className="pdf-footer">
              <h4>Date: {item.date}</h4>
              <h4>Time: {item.time}</h4>
            </div>

            {/* <div className="pdf-address">
            <p>Venue: {item.venue}</p>
          </div> */}
          </div>
        ))}
      </div>
      <button onClick={generatePDFs}>Download All PDFs</button>
    </div>
  );
};
